<template>
  <div>
    <v-btn icon @click="dialog = true">
      <v-icon>mdi-delete</v-icon>
    </v-btn>

    <SysDialog
      v-model="dialog"
      titulo="Excluir Categoria"
      txtBotao="confirmar"
      :largura="400"
      content-class="bra-20"
      ocultar_botao_fechar
      @click:primary="deletarCategoria()"
    >
      <p>Deseja realmente excluir a categoria: "{{ categoria.nome_categoria }}"?</p>
    </SysDialog>
  </div>
</template>

<script>
import { deletarCategoria } from '@/api/categoriaCompraMateriaPrima';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue'

export default {
  components: { SysDialog },
  props: {
    categoria: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    deletarCategoria() {
      this.$store.dispatch('loading/addRequisicao',
        deletarCategoria(this.categoria.id_categoria)
          .then(() => {
            this.$emit('atualizar-tela-inicial-categoria');
            this.dialog = false;
          })
      );
    }
  }
}
</script>

<style>

</style>
